const INSTAGRAM_USER_AGENT_PATTERNS = [/instagram/i]

const ANDROID_USER_AGENT_PATTERN = /android/i

const getUserAgent = () => {
  if (typeof navigator === "undefined") {
    return ""
  }

  return navigator.userAgent || ""
}

export const isInstagramInAppBrowser = (): boolean => {
  const userAgent = getUserAgent()

  return INSTAGRAM_USER_AGENT_PATTERNS.some((pattern) => pattern.test(userAgent))
}

export const openCurrentPageOutsideInAppBrowser = (): boolean => {
  if (typeof window === "undefined") {
    return false
  }

  const currentUrl = window.location.href

  const isAndroid = ANDROID_USER_AGENT_PATTERN.test(getUserAgent())

  if (isAndroid) {
    const withoutProtocol = currentUrl.replace(/^https?:\/\//, "")

    window.location.href = `intent://${withoutProtocol}#Intent;scheme=https;package=com.android.chrome;end`

    return true
  }

  window.open(currentUrl, "_blank", "noopener,noreferrer")
  return true
}
